export const NEXT_STEP = "resetPassword/NEXT_STEP";
export const PREV_STEP = "resetPassword/PREV_STEP";
export const SET_CONTACT = "resetPassword/SET_CONTACT";
export const SET_CONTACTS = "resetPassword/SET_CONTACTS";
export const SET_TOKEN = "resetPassword/SET_TOKEN";
export const SET_STEP = "resetPassword/SET_STEP";
